export const toCultureIndependentString = (value) => {
  if (value === null || value === undefined || value === "") return ""
  return String(value).replace(",", ".")
}

export const parseNumberFromString = (value) => {
  if (!value || value === "") return ""
  const parsed = parseFloat(String(value).replace(",", "."))
  return isNaN(parsed) ? "" : parsed
}

const _fmtHM = (h, m) => (m ? `${h}h ${m}m` : `${h}h`)

export const formatTime = (time) => {
  if (!time) return ""
  const [h, m] = time.split(":")
  const hh = parseInt(h),
    mm = parseInt(m)
  return `${hh}:${String(mm).padStart(2, "0")}`
}

export const formatRoundUpDuration = (seconds) => {
  if (!seconds || seconds <= 0) return ""
  const totalMins = Math.ceil(seconds / 900) * 15
  return _fmtHM(Math.floor(totalMins / 60), totalMins % 60)
}

export const formatDuration = (seconds) => {
  if (isNaN(seconds)) {
    return "NaN"
  }
  if (!seconds || seconds <= 0) return ""
  const totalMins = Math.round(seconds / 60)
  return _fmtHM(Math.floor(totalMins / 60), totalMins % 60)
}

export const fmtSec = (s) => {
  if (!s || s <= 0) return ""
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? h + "h " + m : m + " min"
}

export const fmtMin = (m) => {
  if (!m || m <= 0) return ""
  const h = Math.floor(m / 60)
  const min = m % 60
  return h > 0 ? h + "h " + min + "m" : min + "m"
}

export const createQuickDates = (startOffset, endOffset) => {
  const result = []
  const today = dayjs().startOf("day")

  const nthWeekday = (n) => {
    let d = today
    let count = 0
    const dir = n >= 0 ? 1 : -1
    while (true) {
      if (d.day() !== 0 && d.day() !== 6) {
        if (count === Math.abs(n)) return d
        count++
      }
      d = d.add(dir, "day")
    }
  }

  for (let offset = startOffset; offset <= endOffset; offset++) {
    const d = nthWeekday(offset)
    let label
    if (offset === 0) {
      label = "danes"
    } else if (d.isSame(today.add(1, "day"), "day")) {
      label = "jutri"
    } else {
      label = d.format("ddd")
    }
    result.push({ label, offset, date: d, isToday: offset === 0, isPast: offset < 0, isoDate: d.format("YYYY-MM-DD") })
  }
  return result
}
